import React from "react";
import { Show, SimpleShowLayout, TextField, DateField } from "react-admin";
import { dateOptions } from "utils/options";

const CompanyShow = () => {
  return (
    <Show title="Детайли на абонаментна кампания">
      <SimpleShowLayout>
        <TextField
          label="Име на абонаментна кампании"
          source="name_bg"
        />
        <DateField
          label="Начална дата на абонаментната кампания"
          source="start_date"
          locales={"bg"}
          options={dateOptions}
        />{" "}
        <DateField
          label="Крайна дата на абонаментната кампания"
          source="end_date"
          locales={"bg"}
          options={dateOptions}
        />{" "}
        <DateField
          label="Дата на начало на абонаментите"
          source="subscription_start_date"
          locales={"bg"}
          options={dateOptions}
          fullWidth
        />
      </SimpleShowLayout>
    </Show>
  );
};

export default CompanyShow;
